import { dateToShow, dateToMysql } from '@/helpers/dates'
import { success } from '@/utils/alert'

const prepareShow = dependent => {
  dependent.birthdate = dateToShow(dependent.birthdate)

  return dependent
}

const prepareSave = dependent => {
  dependent.birthdate = dateToMysql(dependent.birthdate)

  return dependent
}

export default {
  prepareShow,
  prepareSave,
  /**
   * Mesnagem de sucesso apos alteração ou inclusão.
   */
  afterSave (dependent) {
    this.dependent = prepareShow(dependent)

    this.isEdited = true
    success('Depedente salvo com sucesso.')
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/dependents/resources/methods.js